import React from "react";
import "../App.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import onlineImage from "../data/online.jpeg";
import pharmaImage from "../data/pharma.jpeg";
import overallImage from "../data/overall.jpeg";

const categories = [
  { id: "online", label: "Online", image: onlineImage },
  { id: "pharma", label: "Pharma", image: pharmaImage },
  { id: "all", label: "All Products", image: overallImage },
];

const ProductsList = () => (
  <div className="container">
    <h1 className="text-center">OUR PRODUCTS</h1>
    <div className="row">
      {categories.map((category) => {
        const destination = `/productscategories?category=${category.id}`;
        return (
          <div key={category.id} className="col-12 col-md-4 p-3 text-center">
            <Button component={Link} to={destination} className="mb-2">
              {category.label}
            </Button>
            <Link to={destination} aria-label={`View ${category.label} products`}>
              <img
                src={category.image}
                alt={`${category.label} product catalogue`}
                style={{ display: "block", width: "100%", height: "auto" }}
              />
            </Link>
          </div>
        );
      })}
    </div>
  </div>
);

export default ProductsList;
